var React = require('react');

function Updownarrows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.9656 12.2582L13.2826 14.5753M13.2826 14.5753L15.6003 12.2582M13.2826 14.5753L13.283 4.92188","stroke":"#8C8C8C","strokeWidth":"1.44","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.03462 7.2396L6.71761 4.92188M6.71761 4.92188L4.3999 7.2396M6.71761 4.92188L6.7173 14.5756","stroke":"#8C8C8C","strokeWidth":"1.44","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Updownarrows.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Updownarrows;

Updownarrows.default = Updownarrows;
